import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-129464d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"6rem","height":"8rem"},
  src: _imports_0,
  alt: "GEP Group"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-weight":"500","font-size":"1.5rem"} }, "GEP GROUP", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"10"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const backToHome = () => {
  router.push('/home');
}

const handleSelect = (key: string, keyPath: string[]) => {
  
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    router: "",
    "default-active": _unref(route).path,
    class: "el-menu-demo",
    mode: "horizontal",
    "background-color": "#232946",
    "text-color": "#fffffe",
    "active-text-color": "#eebbc3",
    ellipsis: false,
    onSelect: handleSelect,
    style: {"height":"6rem"}
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_menu_item, { onClick: backToHome }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_el_menu_item, { index: "/home" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "/about" }, {
        default: _withCtx(() => [
          _createTextVNode("About")
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "/education" }, {
        default: _withCtx(() => [
          _createTextVNode("Education")
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "/training" }, {
        default: _withCtx(() => [
          _createTextVNode("Training")
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "/employment" }, {
        default: _withCtx(() => [
          _createTextVNode("Employment")
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "/contact" }, {
        default: _withCtx(() => [
          _createTextVNode("Contact")
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, { index: "/staff" }, {
        default: _withCtx(() => [
          _createTextVNode("Staff Portal")
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})